module.exports = __webpack_public_path__ + "media/components/global/promos/redirector-app-notice/img/photopin-0c98c63c53d68562460aa92665c13595.svg";